/**
 * App navigation flow to different places of Home Menu
 * @module Home-Navigation-Routes
 */

import { Route, Routes } from "react-router-dom";
import { route } from "../globals/constants";
import Home2Page from "../app/components/home/home2";

/**
 * @returns Describes navigation for Home Menu:
 ** {@link Home2Page | Home Page Style 2}
 */
const HomeRoutes = () => {
    return (
        <Routes>
            <Route path={route.INITIAL} element={<Home2Page />} />
            <Route path={route.home.HOME2} element={<Home2Page />} />
            {/* Redirect all other home routes to Home2 */}
            <Route path="*" element={<Home2Page />} />
        </Routes>
    )
}
export default HomeRoutes;